import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownHeader',
    baseStyle: {
      minWidth: '120px',
      border: 'none',
      backgroundColor: theme.colors.black23,
      color: theme.colors.text,
      fontSize: theme.sizes['-1'],
      padding: [
        `${theme.space.s} ${theme.space.s} ${theme.space.s} ${theme.space['s']}`,
        `${theme.space.xs} ${theme.space.xs} ${theme.space.xs} ${theme.space['2xs']}`
      ],
      borderRadius: theme.sizes['-1'],

      '& svg': {
        paddingLeft: theme.space.xs
      },

      '&:hover': {
        backgroundColor: theme.colors.muted10
      }
    }
  };
}
